import { render, staticRenderFns } from "./MockupPositioner.vue?vue&type=template&id=679ea4a4&scoped=true"
import script from "./MockupPositioner.vue?vue&type=script&lang=js"
export * from "./MockupPositioner.vue?vue&type=script&lang=js"
import style0 from "./MockupPositioner.vue?vue&type=style&index=0&id=679ea4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679ea4a4",
  null
  
)

export default component.exports